




















































































































































































































import AbpBase from "../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '../lib/util'
import {GetPatDlyRecord} from '../api/hd/index'

@Component
export default class extends AbpBase {
	@Prop({type: Boolean, default: false}) value: boolean;
	@Prop({type: Object, default: {}}) data: any;
	showNum = true

	mounted() {
		console.log(this.data)
		if (!this.data.showNum) {
			this.showNum = false
		}
		this.getPatDlyRecord({DialysisSignId: this.data.dialysisSignId})
	}

	//历史单据id
	ids: any = []
	activeIdsIndex = 0
	recordInfo: any = {}
	falg = 0
	async getPatDlyRecord(data: any) {
		let res = await GetPatDlyRecord(data)
		// console.log(res)
		this.ids = res.objects.dialysisSignIds
		this.recordInfo = res.objects
		if(this.falg<1){
			this.activeIdsIndex = res.objects.dialysisSignIds.length-1
		}
		this.falg++;
	}

	nextOrlast() {
		this.getPatDlyRecord({DialysisSignId: this.ids[this.activeIdsIndex]})
	}


	cancel() {
		this.$emit('input', false);
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/patDlyRecord.vue